import { useContext } from 'react';
import { MenuContext } from "../context/MenuContext.js";
export function useInputKeyDownHandling(onKeyDown) {
  const {
    virtualItemRef
  } = useContext(MenuContext);
  return e => {
    if (e.key === 'Enter') {
      virtualItemRef?.current?.click();
    } else {
      onKeyDown?.(e);
    }
  };
}